export class AdvancedSearchExport
{
  Id:number;
  Faa_Site: string;
  Loc_Id: string;
  Airport_Name: string;
  Associated_City: string;
  State: string;
  Region: string;
  Ado: string;
  Airport_Use: string;
  Latitude: string;
  Longitude: string;
  Airport_Ownership: string;
  Part139: string;  // <- far139Ndx
  NPIAS_Service_Level: string; // <- serviceLevelName: string;
  NPIAS_Hub_Type: string;
  Control_Tower: string;  // <- ctrlTwr: string;
  Fuel: string;
  Other_Services: string;
  Based_Aircraft_Total: string;  // <- based: string;
  Total_Operations: string;  // <- operationsTotal: string;
  Asset_Role: string;  // <- assetRank: string;
  Elevation: string;  // <- arptElev:string;
  OwnerName: string;  // <-owner: string;
  OwnerAddress: string;
  OwnerCityStZip: string;  // <- ownerAddressCsz: string;
  OwnerPhone: string;
  ManagerName: string; // <- manager: string;
  ManagerAddress: string;
  ManagerCityStZip: string; // <- managerAddressCsz: string;
  ManagerPhone: string;
  RunwayLength: string;
  RunwayWidth: string;
}
